import styled from "styled-components";

import { alpha, rem, size } from "@styles/Utilities.styled";


export const StyledDocViewer = styled.div`
  #react-doc-viewer {
    #header-bar {
      padding-top: 1rem;
    }

    #file-name {
      color: var(--clr-primary-700);
      font-weight: 500;
    }

    #doc-nav {
      &-info {
        color: var(--clr-primary-700);
        font-size: ${rem(13)};
      }

      button {
        background-color: var(--clr-primary-400);

        svg {
          width: 50%;
        }
      }
    }

    #pdf-controls {
      gap: 0.25rem;
      box-shadow: none !important;
      border-bottom: 1px solid ${alpha("var(--clr-black)", 0.1)};

      a,
      button {
        background-color: var(--clr-primary-400);

        svg {
          width: 70%;

          path,
          polygon {
            fill: white;
          }
        }
      }
    }

    #pdf-pagination {
      margin-right: auto;

      &-info {
        font-size: ${rem(13)};
        color: var(--clr-primary-700);
      }

      button {
        svg {
          width: 40%;
        }
      }
    }

    #no-renderer {
      margin-top: 2rem;
      padding-inline: 1.5rem;
      padding-bottom: 1rem;
      color: var(--clr-rose);

      &-download {
        ${size("fit-content", "unset")}
        padding: 0.5em 1em;
        margin-top: 1rem;
        border-radius: var(--border-radius-2);
        font-size: ${rem(14)};
        color: var(--clr-white);
        background-color: var(--clr-accent);
      }
    }
  }
`;
